import { FormatChannel } from "./types";

// Campaign type (+ subtype for direct mail) to the print-format catalogue channel.
export function toFormatChannel(type?: string | null, subtype?: string | null): FormatChannel | null {
  switch (type) {
    case "HANDTOHAND":
      return "H2H";
    case "LETTERBOX":
      return "D2D";
    case "INSERTS":
      return "INSERTS";
    case "DIRECTMAIL":
      if (subtype === "ADM") return "ADM";
      if (subtype === "EDDM") return "EDDM";
      return null;
    default:
      return null;
  }
}
